<h2 class="text-center">Пример рассылки</h2>
<app-message-sender
  [contextMenuSubject]="message"
  [class.open]="message.id === (interfaceService.openDropdown$ | async)?.id"
  [attr.data-id]="message.id"
  [message]="message"
  [Service]="Service"
  class="message read message-sender px-3 px-lg-6">
</app-message-sender>
